import { render, staticRenderFns } from "./UserPortal.vue?vue&type=template&id=74780134&"
import script from "./UserPortal.vue?vue&type=script&lang=js&"
export * from "./UserPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports